import type { ColumnDef } from '@tanstack/react-table';

import {
    type GetAllRegularTotemClosedReceptionDayQuery,
    type TotemClosedReceptionDayFragmentFragment,
} from 'data/__generated__';
import { textColumn } from 'components/DataTable';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';

export type TotemClosedReceptionDayRow =
    GetAllRegularTotemClosedReceptionDayQuery['getAllRegularTotemClosedReceptionDay'][number];

type TotemClosedReceptionDayFilterInput = {
    searchValue: string;
};

type TotemClosedReceptionDayColumnsParams = {
    todayDateFormatted: string;
    archiveLoading: boolean;
    onAbort: (totemClosedReceptionDay: TotemClosedReceptionDayFragmentFragment) => void;
    onArchive: (totemClosedReceptionDayId: string) => void;
};

export const getTotemClosedReceptionDaysColumns = ({
    todayDateFormatted,
    archiveLoading,
    onAbort,
    onArchive,
}: TotemClosedReceptionDayColumnsParams): ColumnDef<TotemClosedReceptionDayRow, unknown>[] => [
    textColumn<TotemClosedReceptionDayRow, TotemClosedReceptionDayFilterInput>({
        accessorKey: 'date',
        header: 'Date',
        defaultVisible: true,
    }),
    textColumn<TotemClosedReceptionDayRow, TotemClosedReceptionDayFilterInput>({
        id: 'abortButton',
        accessorFn: () => '',
        header: 'Annuler',
        defaultVisible: true,
        cell: ({ row }) => (
            <TotemPrimaryButton
                onClick={(e: React.MouseEvent) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onAbort(row.original);
                }}
                disabled={archiveLoading || row.original.date < todayDateFormatted}
            >
                Annuler
            </TotemPrimaryButton>
        ),
    }),
    textColumn<TotemClosedReceptionDayRow, TotemClosedReceptionDayFilterInput>({
        id: 'archiveButton',
        accessorFn: () => '',
        header: 'Archiver',
        defaultVisible: true,
        cell: ({ row }) => (
            <TotemPrimaryButton
                onClick={(e: React.MouseEvent) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onArchive(row.original._id);
                }}
                disabled={archiveLoading || row.original.date > todayDateFormatted}
            >
                Archiver
            </TotemPrimaryButton>
        ),
    }),
];
